import type { LanguageOption } from '@/types/settings/language-option';

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'fr', flagKey: 'FR' },
  { code: 'en', flagKey: 'GB' },
];
